
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 17a3 3 0 100-6 3 3 0 000 6zM37 17a3 3 0 100-6 3 3 0 000 6zM34.935 18.537l-6.56 11.344c-.183.314-.485-.05-.367-.44l2.335-7.75a.609.609 0 00-.009-.374.346.346 0 00-.083-.134.162.162 0 00-.111-.049h-4.912a.171.171 0 01-.126-.064.403.403 0 01-.084-.17.626.626 0 01-.014-.22.508.508 0 01.061-.197l6.085-10.366c.176-.3.47.029.372.419l-1.745 6.917a.626.626 0 00.02.363.33.33 0 00.084.126.16.16 0 00.108.044l4.78-.1c.044-.001.089.02.127.061.038.041.067.1.085.17.018.07.023.147.015.221a.512.512 0 01-.06.198","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.14 29h.448c.24 0 .43-.294.41-.638a25.229 25.229 0 00-.163-1.666L28.141 29zm-1.22-7.866a5.52 5.52 0 00-1.426-1.382l-.429.73a.508.508 0 00-.06.197.629.629 0 00.013.22c.017.07.046.13.084.171a.172.172 0 00.126.064h1.691zm-3.327-2.094A4.674 4.674 0 0023 19c-1.172.007-5.407.413-5.999 9.362-.019.344.171.638.41.638h8.645c.011-.046.024-.092.037-.137l.001-.003 1.726-5.726h-2.595a2.17 2.17 0 01-1.615-.731 2.4 2.4 0 01-.533-1.02 2.628 2.628 0 01-.06-.93c.034-.297.125-.642.32-.977l.003-.006.253-.43zM31.23 28.939c.054.039.116.061.182.061h11.176c.24 0 .43-.294.41-.638C42.408 19.413 38.173 19.007 37 19c-.032 0-.067 0-.104.002a2.446 2.446 0 01-.229.535l-.713-.413h-.003l.715.415-5.436 9.4zm.445-4.765c.592-2.073 1.466-3.317 2.35-4.063l-2.35 4.063z","fill":"#E7E5EC"}})])
          )
        }
      }
    